import dataStore from './store'

const nextViewName = function() {

    let currentKey;

    if(dataStore.activeViewIndex + 1 === Object.size(dataStore.viewActive) ){
        currentKey = Object.keys(dataStore.viewActive)[0];
    } else {
        currentKey = Object.keys(dataStore.viewActive)[dataStore.activeViewIndex + 1];
    }

    if(currentKey === 'normal') {
        return dataStore.currentSlide.type === 'map' ? 'map_view' : 'image_view';

    } else if(currentKey === 'heatmap') {
        return 'heatmap_view';

    } else {
        return 'list_view';
    }

};

const getLabelForGoodBad = function (lang, slide, string) {

    if(string === null || slide === null) {
        return
    }

    let values = {
        'good' : slide.good_label !== null ? slide.good_label.toLowerCase() : lang['good'],
        'bad' : slide.bad_label !== null ? slide.bad_label.toLowerCase() : lang['improve'],
    }

    return values[string];

};

export {
    nextViewName,
    getLabelForGoodBad
}
